import { RequirementDto } from 'theSource/queries';

export const isRequirementFulfilled = (
  password: string,
  requirement: RequirementDto
) => {
  let valid = false;
  const lookup = requirement.lookup_code;

  switch (lookup) {
    case 'password_length':
      const descriptionValues = requirement.description.match(/\d+/g) || [];
      const requredLength = Number(descriptionValues[0]) || 0;
      valid = password.length >= requredLength;
      break;
    case 'alphanumeric':
      valid = /[a-zA-Z]/.test(password) && /\d/.test(password);
      break;
    case 'uppercase':
      valid = /[A-Z]/.test(password);
      break;
    case 'lowercase':
      valid = /[a-z]/.test(password);
      break;
    case 'special_character':
      valid = /[^a-zA-Z0-9]/.test(password);
      break;
  }
  return valid;
};
